import { render, staticRenderFns } from "./AnswerOver.vue?vue&type=template&id=411310f3&scoped=true&"
import script from "./AnswerOver.vue?vue&type=script&lang=js&"
export * from "./AnswerOver.vue?vue&type=script&lang=js&"
import style0 from "./AnswerOver.vue?vue&type=style&index=0&id=411310f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411310f3",
  null
  
)

export default component.exports